import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = { isLoading: false, data: null, errors: [] };

export const getSettings = createAsyncThunk('settings/getSettings', async (_, thunkApi) => {
  try {
    const { data } = await axios.get('/api/get_settings');
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const updateSettings = createAsyncThunk('settings/updateSettings', async (args, thunkApi) => {
  try {
    const { data } = await axios.put('/api/update_settings', args, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  extraReducers: {
    [getSettings.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [getSettings.fulfilled]: (state, action) => { state.isLoading = false; state.data = action.payload.data; },
    [getSettings.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload?.errors ?? []; },

    [updateSettings.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [updateSettings.fulfilled]: (state, action) => { state.isLoading = false; state.data = action.payload.data; },
    [updateSettings.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload?.errors ?? []; },
  }
});

export default settingsSlice.reducer;
